import { IconProps } from '../icon';

export function CheckV3Icon(props: IconProps) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.4 0L7.28 17.7233L2.6 14.17H0L7.28 26L26 0H23.4Z"
        fill="white"
      />
    </svg>
  );
}

export default CheckV3Icon;
